import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { CampaignService } from 'src/app/services/campaign.service';
import { Router } from '@angular/router';
import { TenantDialogComponent } from './tenant-dialog/tenat-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { TenantService } from 'src/app/services/tenant.service';
import { TenantLocalService } from 'src/app/services/tenantlocal.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  defaultUserImage = 'assets/img/default.png';
  user: any;
  tenant: any = {};

  constructor(
    public userService: UserService,
    public campaignService: CampaignService,
    private router: Router,
    private dialog: MatDialog,
    private tenantService: TenantService,
    private tenantlocalservice: TenantLocalService,
  ) { }

  ngOnInit() {
    const slug = this.tenantlocalservice.getTenantSlug();
    this.tenantService.getTenantbySlug(slug).subscribe({
      next: (res) => {
        this.tenant = res;
        this.tenantlocalservice.setTenant(res);
      },
      error: (err) => {
        console.error(err);
      },
    });

    this.userService.user.subscribe(user => {
      this.user = user;
    });
  }

  profile() {
    this.router.navigate(['/profile'])
  }

  logout() {
    this.userService.logout();
    this.campaignService.cleanData();
  }

  OpenModal() {
    const dialogRef = this.dialog.open(TenantDialogComponent, {
      disableClose: true,
      width: '450px',
      data: {
        user: this.user,
        tenant: this.tenant,
      }
    });
  }

}
